module.exports = __webpack_public_path__ + "img/default-snap.5231a16e.svg";